import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";

import HeroSection from "./HeroSection";
import OverviewSection from "./OverviewSection";
const ContentSection = lazy(() => import("./ContentSection"));
const AdvantageSection = lazy(() => import("./AdvantageSection"));
const BenefitSection = lazy(() => import("./BenefitSection"));

const CustomDevelopment = () => {
  return (
    <>
      <Helmet>
        <title>
          Expert Software Consulting Services | Accelerate Digital
          Transformation
        </title>
        <meta
          name="description"
          content="Boost your business growth with expert software consulting. Our senior consultants provide strategic guidance, optimized systems, and flexible solutions for smarter decision-making and accelerated digital transformation."
        />
        <meta
          name="keywords"
          content="IT strategy consulting, technology consulting, business technology solutions, software project management, software optimization, IT consulting experts, strategic software solutions"
        />
      </Helmet>

      <section className="bg-white font-poppins overflow-hidden">
        <HeroSection />
        <OverviewSection />

        <Suspense fallback={<div className="h-[400px]" />}>
          <ContentSection />
          <AdvantageSection />
          <BenefitSection />
        </Suspense>
      </section>
    </>
  );
};

export default CustomDevelopment;
